customElements.define(

  "cc-cta-button", 

  class extends HTMLElement{

    connectedCallback(){

        const href = this.getAttribute("href");
        const label = this.textContent;

        this.innerHTML = `

            <a href="${href}" class="cc-cta-button">${label}</a>  

        `;

    }
        
  }

);